import axios from 'axios'
import { Message } from 'element-ui'
import Qs from 'qs'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { getLanguage } from "@/i18n/i18n.js"; 

let myBaseURL = process.env.VUE_APP_BASE_API
// console.log('baseURL', myBaseURL)
localStorage.setItem('baseURL', myBaseURL)
const service = axios.create({
  baseURL: myBaseURL, 
  timeout: 5000*6 // 请求超时时间
})

//这是post请求，可以直接发送对象
// service.defaults.transformRequest = [(data)=> {return Qs.stringify(data)}]
// <!-- {{$i18n.locale==='zh-CN'?'中文':'English'}} -->

// 可以在请求头添加对应信息
service.interceptors.request.use(config => {
  config.headers = config.headers || {};
  
  // 设置语言
  let lang = getLanguage();
  config.headers['lang'] = lang === 'en-US' ? 'en' : 'cn';

  // 设置提交后端的格式，不同模块的接口标准不一样，充电桩是Java的，后台懒得改就用json了
  if (config.url.includes('/sys/')) {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  }else{
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
    // 手动将 data 转成 form-urlencoded 字符串
    if (config.data && typeof config.data === 'object' && !(config.data instanceof FormData)) {
      config.data = Qs.stringify(config.data);
    }
  }
  
  // token
  const token = getToken();
  if (token) {
    config.headers['Authorization'] = token;
  }

  return config
}, error => {
  return Promise.reject(error)
})


/**
* respone拦截器
* 对请求返回的错误进统一处理
*/
service.interceptors.response.use(
  response => {
    // console.log('response',response)
	  /**
	  * 对接口请求成功返回的错误进统一处理
		*/
    const res = response.data
    // code大于40000的为全局错误码，
    if(res.status > 200) {
      // 401：接口权限不足
      if(res.status == 401) {
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000
        })
        store.dispatch('logout').then(() => {
          location.reload()// 为了重新实例化vue-router对象 避免bug
        })
      }else{
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(res.message)
    }

    // status小于200的，为不可预料的错误码
    if (res.status < 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(res.message)
    }

    // status为200视为正常
    return res
  },
  error => {
  	/*
  	* 对接口请求失败进行统一处理
  	*/
    console.log('err:' + error)// for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    // return Promise.reject(error)
  }
)

export default service
